import React from 'react';
import { Header, Footer } from './components/Layout';
import { Home } from './pages/Home';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-beige-100">
      <Header />
      <main>
        <Home />
      </main>
      <Footer />
    </div>
  );
};

export default App;
